import React from "react";
import PageHero from "../components/PageHero";
import Stats from "../components/Stats";
import Certifications from "../components/Certifications";
import ContactForm from "../components/ContactForm";
import { whyChoose, company } from "../mock";
import { CheckCircle2 } from "lucide-react";
import useSEO from "../hooks/useSEO";

const values = [
  { title: "Integrity First", text: "We give honest assessments — the best solution for your home, not the quickest sale." },
  { title: "Quality Craftsmanship", text: "Certified crews, premium materials, and workmanship backed by full warranties." },
  { title: "Transparency", text: "Clear pricing and communication from the free inspection through final clean-up." },
  { title: "Family Owned", text: "A licensed, family-operated company that treats your home like our own." },
];

const About = () => {
  useSEO({
    title: "About Fab Build Pro | Family-Owned Roofer in Vienna, VA",
    description: "Fab Build Pro is a family-owned, licensed roofing & general contractor in Vienna, VA serving Northern Virginia, D.C. & Maryland. GAF Master Elite certified.",
    crumbs: [{ name: "About", path: "/about" }],
  });
  return (
    <>
      <PageHero
        title="About Fab Build Pro"
        subtitle="Built on Integrity. Driven by Results. Trusted by Thousands across the DMV."
      />

      <section className="bg-brand-cream py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img src="/img/about-hero.webp" alt="Fab Build Pro team" className="w-full h-[440px] object-cover" />
          </div>
          <div>
            <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
              Our Story
            </p>
            <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl mb-5">
              Protecting Homes with Honesty, Quality & Care
            </h2>
            <div className="space-y-4 text-slate-600 leading-relaxed">
              {whyChoose.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <p data-testid="about-entity-summary">
                Fab Build Pro is a family-owned roofing and general contractor
                headquartered at {company.address}. We are licensed in Virginia
                (Class A), Washington, D.C. (HIC) and Maryland (MHIC), and we are
                a GAF Master Elite certified residential roofing contractor
                providing roof repair, roof replacement, storm damage
                restoration, siding, windows, doors, gutters and remodeling
                across Northern Virginia, D.C. and Maryland.
              </p>
              <p>
                We stand behind our work, our word, and our customers. Because
                your roof is our responsibility — and your peace of mind is our
                promise.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-sand py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl">
              What We Stand For
            </h2>
            <div className="w-20 h-1 bg-brand-orange rounded-full mx-auto mt-4" />
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-6 border border-black/5 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all">
                <CheckCircle2 className="w-9 h-9 text-brand-orange mb-4" />
                <h3 className="font-display font-bold text-brand-navy text-lg mb-2">{v.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Stats />
      <Certifications />
      <ContactForm />
    </>
  );
};

export default About;
